module.exports = __webpack_public_path__ + "img/2s.acb51de8.png";